import { useState, useEffect } from "react";
import { createModel } from "hox";
import { IPgProps, ISearchPage } from "@/types/ScmTypes";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, } from "@/utils/constants";
import { psiService, IPsiSearchFields, IPsiDetail, IStatistics, IPsiDetailPurchasePin, IGoodsRecordModal, IDetailsDrawer } from "./psiService";
import useGlobalModel from "@/model/globalModel";
import { convertRes2Blob } from "@/utils/exportFile";
import { getRandomStr, transPgToPagination } from "@/utils/utils";
import { TablePaginationConfig } from "antd/lib/table";


export const usePsiModel = createModel(function () {
    const initStatistics = {
        differenceNumTotal: 0,
        occupyDifferenceTotal: 0,
        currentNumTotal: 0,
    }
    const { shopAndOrg, setLoadingInfo } = useGlobalModel(({ shopAndOrg }) => [shopAndOrg]);;
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    //查询条件
    const [searchParam, setSearchParam] = useState<IPsiSearchFields>({});
    //列表数据源
    const [dataSource, setDataSource] = useState<IPsiDetail[]>([]);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    const [descTotal, setDescTotal] = useState<IStatistics>(initStatistics);
    const [loading, setLoading] = useState<boolean>(false);
    //商品明细
    const [purchasePinData, setPurchasePinData] = useState<IPsiDetailPurchasePin[]>([]);
    const [pinPgCfg, setPinPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //单据明细查看
    const [detailsVisible, setDatailsVisible] = useState<IDetailsDrawer>({
        visible: false,
        code: "",
    });
    //弹框
    const initGoodsRecordModal = {
        remainVisible: false,  //进销存剩余数
        occupyVisible: false,  //占用库存数
        startVisible: false,  //期初数
        compensateVisible: false,  //补偿数
        type: "all"
    }
    const [goodsRecordModal, setGoodsRecordModal] = useState<IGoodsRecordModal>(initGoodsRecordModal)

    const onCancel = () => {
        setGoodsRecordModal(initGoodsRecordModal);
    };

    const onOpen = (row: IPsiDetail, { str, type = "all", title = "弹框", field }: any) => {
        setGoodsRecordModal({
            ...initGoodsRecordModal,
            row,
            [str]: true,  //打开对应弹框
            type, title, field
        });
    }

    const updateSearchParam = (updateParam: IPsiSearchFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }

    //重置
    const resetSearchParam = () => {
        setSearchParam({});
        setSelectedRowKeys([]);
        loadData(initPgCfg, {});
    }

    const loadData = async (page?: ISearchPage, searchValue: IPsiSearchFields = searchParam) => {
        setLoading(true)
        try {
            const shopParam = {
                shopType: searchValue.shopId !== undefined ? 1 : shopAndOrg.shopType,
                shopId: searchValue.shopId ?? shopAndOrg.shopId
            };
            const searchParams = {
                ...searchValue,
                ...shopParam,
                pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            }
            let { retData } = await psiService.page(searchParams);
            let { retData: Data } = await psiService.statistics(searchParams);
            const { records, ...pg } = retData;
            setDataSource(records.map(item => ({
                ...item,
                key: getRandomStr()
            })));
            setPgCfg(transPgToPagination(pg));
            setLoading(false)
            setDescTotal(Data);
        } catch {
            setLoading(false);
            setDataSource([])
        }
    }

    //导出
    const exportPsi = async (searchValue: IPsiSearchFields = searchParam) => {
        setLoadingInfo({ loadingVisible: true, txt: "快速导出中" });
        try {
            const shopParam = {
                shopType: searchValue.shopId !== undefined ? 1 : shopAndOrg.shopType,
                shopId: searchValue.shopId ?? shopAndOrg.shopId
            };
            const searchParams = {
                ...searchValue,
                ...shopParam,
                pageSize: -1,
                pageNum: 1,
            }
            let result = await psiService.export(searchParams);
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            convertRes2Blob(result);
        } catch { setLoadingInfo({ loadingVisible: false, txt: "" }) }
    }

    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        /***method***/
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData, exportPsi,
        descTotal, setDescTotal,
        purchasePinData, setPurchasePinData,
        pinPgCfg, setPinPgCfg,
        goodsRecordModal,
        onCancel, onOpen,
        detailsVisible, setDatailsVisible,
        loading
    }
});


